import React from "react";
import ReactModal from "react-modal";

import { Icon, close } from "Icons/index";

import cx from "classnames";
import s from "./smallModal.scss";

const DefaultProps = {
  label: "Modal",
  className: "",
  opened: false,
};

class Modal extends React.Component {
  state = {};

  componentDidMount() {
    if (this.props.onEnter) {
      window.addEventListener("keydown", this.triggerEnterAction, false);
    }
  }

  componentWillUnmount() {
    if (this.props.onEnter) {
      window.removeEventListener("keydown", this.triggerEnterAction);
    }
  }

  triggerEnterAction = (e) => {
    if (e.key === "Enter" && this.props.onEnter && this.props.opened) {
      this.props.onEnter(e);
    }
  };

  closeModal = () => {
    document.body.style.overflowY = "auto";
    if (this.props.closeModal) {
      this.props.closeModal();
    }
  };

  // to enable close of the modal when
  // user clicks on the body
  // onRequestClose={this.closeModal}
  render() {
    const {
      className,
      title,
      children,
      label,
      opened,
      largeModal,
      withForm,
      modalClassName = "",
      isWarning = false,
      mediumModal = false,
      showCloseIcon = false,
      footerComponent,
    } = this.props;
    if (!opened) {
      document.body.style.overflowY = "auto";
      return <span />;
    }

    document.body.style.overflowY = "hidden";
    return (
      <ReactModal
        ariaHideApp={false}
        className={cx(className, s.wrapModal, {
          [s.largeModal]: largeModal,
          [s.withForm]: withForm,
        })}
        overlayClassName={s.overlay}
        isOpen={opened}
        contentLabel={label}
      >
        <div className={cx(s.modal, modalClassName, { ["w-[33rem]"]: mediumModal })}>
          {title && (
            <div className={cx(s.headerModal, "justify-between", { [s.headerModalWarning]: isWarning })}>
              <div className={s.title}>{title}</div>

              {showCloseIcon && (
                <div
                  onClick={this.closeModal}
                  className="flex items-center justify-center rounded hover:cursor-pointer hover:bg-[--bg-d10] p-1"
                >
                  <Icon svg={close} width="1rem" height="1rem" />
                </div>
              )}
            </div>
          )}

          <div className={s.bodyModal}>
            {children}

            {footerComponent}
          </div>
        </div>
      </ReactModal>
    );
  }
}

//Modal.propTypes = {
//   id: PropTypes.string,
//   label: PropTypes.string,
//   opened: PropTypes.bool,
//   closeModal: PropTypes.func
// };
Modal.defaultProps = DefaultProps;

export default Modal;
